var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5658C10.6264 11.5658 8 9.07541 8 6.1579C8 3.24037 10.6264 0.75 14 0.75C17.3736 0.75 20 3.24037 20 6.1579C20 9.07541 17.3736 11.5658 14 11.5658ZM26.75 24.6316V25.25H26H1.25V24.6316C1.25 19.8283 5.558 15.8026 11 15.8026H17C22.4406 15.8026 26.75 19.8284 26.75 24.6316Z",
    stroke: "#424242",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c8124ddbb71336f2b0b38f255e482521.svg";
export { ForwardRef as ReactComponent };